<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="hospital-redemption">
<h1>Hospital Redemption</h1>
<p style="text-indent:0px;">Sanitised halls seep in anxious families,</p>
<p style="text-indent:0px;">As they await loved ones’ results.</p>
<p style="text-indent:0px;">Some stricken by unexpected tragedies,</p>
<p style="text-indent:0px;">Others relieved by news of doctors’ consults.</p><br/>
<p style="text-indent:0px;">Organised chaos by the nurses,</p>
<p style="text-indent:0px;">Reassuring those in distressed wait.</p>
<p style="text-indent:0px;">A chaplain reciting religious verses,</p>
<p style="text-indent:0px;">As a patient to heaven he tries to reinstate.</p><br/>
<p style="text-indent:0px;">Vulnerability is felt within the healing bricks,</p>
<p style="text-indent:0px;">Felt even by the healthy.</p>
<p style="text-indent:0px;">We realise our own clock as it ticks,</p>
<p style="text-indent:0px;">Whether we are destitute or wealthy.</p><br/>
<p style="text-indent:0px;">Two people arrive at lightning pace,</p>
<p style="text-indent:0px;">Scared and afraid of what awaits.</p>
<p style="text-indent:0px;">Three people leave with an exhausted face,</p>
<p style="text-indent:0px;">One a new-born joy with both parents’ traits.</p><br/>
<p style="text-indent:0px;">One day we shall all be in need,</p>
<p style="text-indent:0px;">In need of care and reassuring attention.</p>
<p style="text-indent:0px;">It is with the angels that we shall plead,</p>
<p style="text-indent:0px;">To grant us our eternal redemption.</p><br/>
<p style="text-indent:0px;">The passages of hospitals are all-seeing,</p>
<p style="text-indent:0px;">Having witnessed many things.</p>
<p style="text-indent:0px;">Thank goodness they are filled with caring,</p>
<p style="text-indent:0px;">When tragedy it one day rings.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?0852bfbe